import { promptProjetClaude } from '@admin-pmvb/core'
import { useId, useState } from 'react'
import type { FicheProjet } from '../api'
import { BoutonClaude } from './BoutonClaude'

// Onglet « Claude » d'un projet : le lien vers une session Claude (Cowork de Claude desktop, ou
// claude.ai sur un téléphone) qui travaille sur le projet avec le connecteur Admin PMVB, comme
// « Traiter avec Claude » sur une tâche. Ce qu'on lui demande s'écrit ici ; sans demande, il lit
// le projet et propose la suite. Le prompt part dans l'adresse du lien : rien n'est envoyé d'ici.

export function ClaudeProjet({
  p,
  page,
  lien,
}: {
  p: FicheProjet
  /** La sous-page ouverte (l'objectif : rien de plus que le projet). */
  page: { id: string; titre: string } | null
  lien: string
}) {
  const idDemande = useId()
  const [demande, setDemande] = useState('')
  const [surLaPage, setSurLaPage] = useState(page !== null)
  const prompt = promptProjetClaude(p, lien, {
    ...(surLaPage && page && { page }),
    ...(demande.trim() && { demande }),
  })
  return (
    <div className="claude-projet">
      <p className="discret">
        Ouvre une session Claude sur ce projet : elle lit l’objectif, les pages, les tâches et les
        commentaires par le connecteur Admin PMVB, fait ce que vous lui demandez (ou propose la
        suite), et écrit dans le projet. Elle ne paie, ne déclare et ne signe rien.
      </p>
      <div className="champ">
        <label htmlFor={idDemande}>Ce que Claude doit faire (facultatif)</label>
        <textarea
          id={idDemande}
          value={demande}
          onChange={(e) => setDemande(e.target.value)}
          rows={4}
          maxLength={1500}
          placeholder="Par exemple : rédige le plan du bilan dans l’objectif, puis crée les tâches."
        />
      </div>
      {page && (
        <label className="choix-fil">
          <input
            type="checkbox"
            checked={surLaPage}
            onChange={(e) => setSurLaPage(e.target.checked)}
          />
          Partir de la page « {page.titre} »
        </label>
      )}
      <BoutonClaude prompt={prompt} />
      <details className="prompt-claude">
        <summary>Voir le prompt</summary>
        <pre>{prompt}</pre>
      </details>
    </div>
  )
}
